import React, { useCallback } from "react";
import utils from "../../app/UtilityService";
import { Col } from "@tinqin/tinqin-ui-components/src/grid";
import { getEmptyContent } from "../../utils/containerUtils";

//Connected Column that uses same binding as inner component
//renders a standard Grid Col element
//if bind successfully
//or inner component is not bind (missing bindTo) at all
//or config to always display Column
//otherwise will render empty content
export const SmartColumn = (props) => {
    const renderColumn = useCallback(() => {
        let config = props.config || {};
        let region = config.region || {};
        let data = props.data || {};
        let dataProperties = data.properties || {};
        let hidden = dataProperties.hidden;
        let visible = dataProperties.hasOwnProperty("visible") ? dataProperties.visible : !hidden;
        let extraClasses = region.extraClasses || "";
        //hidden logic implemented with "tq-hide" class to be consistent with SmartContainer
        if (!visible) {
            extraClasses += " tq-hide";
        }

        let resolvedChild = utils.resolve(props.config, {
            index: props.index,
            widgetId: props.widgetId,
            //in case of {dynamicItem}
            itemClassifier: props.itemClassifier,
            //grid wrapper does not necessarily bind to the store, but still can have bindTo
            //and can pass parentBindTo to child components, which reduces configuration complexity
            //parentBindTo: props.computedBindTo || props.config.bindTo || props.parentBindTo
            parentBindTo: props.parentBindTo
        });

        let colProps = {
            extraClasses: extraClasses,
            justifyContent: region.justifyContent,
            gutterAll: region.gutterAll,
            gutterLeft: region.gutterLeft,
            gutterRight: region.gutterRight,
            gutterTop: region.gutterTop,
            gutterBottom: region.gutterBottom,
            skipGutter: region.skipGutter,
            skipGutterLeft: region.skipGutterLeft,
            skipGutterRight: region.skipGutterRight,
            //column width depending on the screen size.
            lg: region.sizeLarge,
            md: region.sizeMedium,
            sm: region.sizeSmall,
            //column offset depending on the screen size.
            offsetWhenLarge: region.offsetLarge,
            offsetWhenMedium: region.offsetMedium,
            offsetWhenSmall: region.offsetSmall,
            //hide column depending on the screen size.
            hideWhenLarge: region.hideLarge,
            hideWhenMedium: region.hideMedium,
            hideWhenSmall: region.hideSmall,
            //column push depending on the screen size.
            pushWhenLarge: region.pushLarge,
            pushWhenMedium: region.pushMedium,
            pushWhenSmall: region.pushSmall,
            //column pull depending on the screen size.
            pullWhenLarge: region.pullLarge,
            pullWhenMedium: region.pullMedium,
            pullWhenSmall: region.pullSmall
        };

        return <Col {...colProps}>{resolvedChild}</Col>;
    }, [props]);

    let data = props.data;
    let config = props.config;
    let bindTo = config.bindTo;
    let region = config.region || {};
    let showEmpty = region.showEmpty;

    //if bind successfully
    //or inner component is not bind at all
    //or config to always display Column
    if (data || !bindTo || showEmpty) {
        return renderColumn();
    } else {
        return getEmptyContent();
    }
};

SmartColumn.displayName = "SmartColumn"; //minification concern

export default utils.connectComponent()(SmartColumn);
